import { filter, find, reverse } from 'lodash';
import store from '@store';
import { getObjectValue } from '@utility/utills';
import { LABEL } from '@veriables';
import getDeviceType from '@utility/deviceType';
import panGreen from '@assets/images/panGreen.svg';
import panYellow from '@assets/images/panYellow.svg';
import panOrange from '@assets/images/panOrange.svg';
import { safeJsonParse } from '@utility/helperFunction';

export const returnSentItems = (check, position) => {
  let sentItems = [];
  let serviceChargeItems = [];
  let discountItems = [];
  if (position.number !== -1) {
    sentItems = Array.isArray(check?.items)
      ? check?.items?.reduce((a, v) => {
        const orderItem = check?.orders[0]?.items?.find(
          d => d.checkItemId === v.id
        );
        const orderJSONParse = orderItem
          ? safeJsonParse(orderItem?.orderJson, {})
          : undefined;
        const seatItem = v?.seats?.find(e => e.seatId === position.id);
        const modifierJsonObj = safeJsonParse(orderJSONParse?.modifierJson, {});
        const modifiers =
          orderItem &&
            orderJSONParse.modifierJson &&
            modifierJsonObj?.hasLinkedMenuItem
            ? modifierJsonObj?.modifiers
            : v.modifiers;
        const menuTypeIditem = check?.Items?.find(
          item => item.menuItemId === v.menuItemId
        );
        const resolvedMenuTypeId =
          modifierJsonObj?.menuTypeId ?? menuTypeIditem?.menuTypeId;
        if (
          seatItem &&
          orderItem &&
          !(
            orderJSONParse.modifierJson &&
            modifierJsonObj?.isLinked
          )
        ) {
          a.push({
            ...v,
            price: seatItem.splitAmount,
            modifiers,
            isCheck: false,
            isSingleMove: false,
            menuTypeId: resolvedMenuTypeId,
            isLinked: orderItem?.orderJson && orderJSONParse.isLinked,
            uniqueIdForLinkedItem:
              orderItem?.orderJson && orderJSONParse.uniqueIdForLinkedItem,
            seatIds: Array.isArray(v?.seats)
              ? v?.seats.map(s => s.seatId)
              : [],
          });
        } else if (seatItem && !orderItem) {
          a.push({
            ...v,
            modifiers,
            isCheck: false,
            isSingleMove: false,
            menuTypeId: resolvedMenuTypeId,
            isLinked: orderItem?.orderJson && orderJSONParse.isLinked,
            uniqueIdForLinkedItem:
              orderItem?.orderJson && orderJSONParse.uniqueIdForLinkedItem,
            seatIds: Array.isArray(v?.seats)
              ? v?.seats.map(s => s.seatId)
              : [],
          });
        }
        return a;
      }, [])
      : [];

    //Service charge arr update for seat
    serviceChargeItems = filter(
      check?.serviceCharges,
      item =>
        !item.seats || item.seats.length === 0 ||
        find(item.seats, seatSplit => seatSplit?.seatId === position?.id)
    );

    for (let i = 0; i < serviceChargeItems.length; i += 1) {
      const singleItm = find(
        serviceChargeItems[i]?.seats,
        singleItem => singleItem?.seatId === position?.id
      );
      serviceChargeItems[i] = {
        ...serviceChargeItems[i],
        id: serviceChargeItems[i]?.id ?? serviceChargeItems[i]?.serviceChargeId ?? `serviceCharge-${serviceChargeItems[i]?.serviceChargeName ?? i}`,
        price: singleItm?.splitAmount ?? serviceChargeItems[i]?.price ?? serviceChargeItems[i]?.amount ?? serviceChargeItems[i]?.serviceChargeAmount ?? serviceChargeItems[i]?.value ?? 0,
        menuItemName: serviceChargeItems[i]?.serviceChargeName || serviceChargeItems[i]?.name || 'Service Charge',
        isCheck: false,
        isSingleMove: false,
        sent: true,
        isServiceCharge: true,
      };
    }
    // discount arr update for seat
    discountItems = filter(
      check?.discounts,
      itm =>
        itm.seats &&
        find(itm.seats, seatSplit => seatSplit?.seatId === position?.id)
    );
    for (let i = 0; i < discountItems?.length; i += 1) {
      const singleItm = find(
        discountItems[i]?.seats,
        singleItem => singleItem?.seatId === position?.id
      );
      discountItems[i] = {
        ...discountItems[i],
        id: discountItems[i]?.id ?? discountItems[i]?.discountId ?? `discount-${discountItems[i]?.discountName ?? i}`,
        price: singleItm?.splitAmount ?? discountItems[i]?.value ?? discountItems[i]?.price,
        menuItemName: discountItems[i]?.discountName,
        isCheck: false,
        isSingleMove: false,
        sent: true,
        isDiscount: true,
        seatIds: [position?.id],
      };
    }
  } else {
    sentItems = Array.isArray(check?.items)
      ? check.items.reduce((a, v) => {
        const orderItem = check?.orders[0]?.items?.find(
          d => d.checkItemId === v.id
        );
        const orderJSONParse = orderItem
          ? safeJsonParse(orderItem?.orderJson, {})
          : undefined;
        const modifierJsonObj = safeJsonParse(orderJSONParse?.modifierJson, {});
        const modifiers =
          orderItem &&
            getObjectValue(
              () => modifierJsonObj?.hasLinkedMenuItem,
              false
            )
            ? safeJsonParse(
              safeJsonParse(orderItem?.orderJson, {})?.modifierJson,
              {}
            )
              .modifiers
            : v.modifiers;
        const menuTypeIditem = check?.items?.find(
          item => item?.menuItemId === v?.menuItemId
        );
        if (
          orderItem &&
          getObjectValue(
            () => !modifierJsonObj?.isLinked,
            false
          )
        ) {
          a.push({
            ...v,
            modifiers,
            isCheck: false,
            isSingleMove: false,
            menuTypeId: menuTypeIditem?.menuTypeId,
            seatIds: Array.isArray(v?.seats)
              ? v?.seats.map(s => s.seatId)
              : [],
          });
        }
        return a;
      }, [])
      : [];
    // Service Charge arr update for table
    const temp = check?.serviceCharges?.length || 0;
    for (let i = 0; i < temp; i += 1) {
      serviceChargeItems.push({
        ...check?.serviceCharges[i],
        id: check?.serviceCharges[i]?.id ?? check?.serviceCharges[i]?.serviceChargeId ?? `serviceCharge-${check?.serviceCharges[i]?.serviceChargeName ?? i}`,
        price: check?.serviceCharges[i]?.price ?? check?.serviceCharges[i]?.amount ?? check?.serviceCharges[i]?.serviceChargeAmount ?? check?.serviceCharges[i]?.value ?? 0,
        menuItemName: check?.serviceCharges[i]?.serviceChargeName || check?.serviceCharges[i]?.name || 'Service Charge',
        isCheck: false,
        isSingleMove: false,
        sent: true,
        isServiceCharge: true,
      });
    }

    // discount arr update for table
    const tmp = check?.discounts?.length || 0;
    for (let i = 0; i < tmp; i += 1) {
      const sIds = Array.isArray(check?.discounts[i]?.seats)
        ? check?.discounts[i]?.seats.map(s => s?.seatId).filter(Boolean)
        : [];
      discountItems.push({
        ...check?.discounts[i],
        id: check?.discounts[i]?.id ?? check?.discounts[i]?.discountId ?? `discount-${check?.discounts[i]?.discountName ?? i}`,
        price: check?.discounts[i]?.value ?? check?.discounts[i]?.price,
        menuItemName: check?.discounts[i]?.discountName,
        isCheck: false,
        isSingleMove: false,
        sent: true,
        isDiscount: true,
        seatIds: sIds,
      });
    }
  }
  return [...sentItems, ...serviceChargeItems, ...discountItems];
};
export const pendingItemList = (cart, position, menuItemsHashTable) => {
  // const pendingItemsList = cart.length > 0 && getObjectValue(() => cart, []).filter((e) => e.pending && !e.isLinked).reduce((a, v) => {
  const pendingItemsList =
    cart.length > 0 &&
    getObjectValue(() => cart, [])
      .filter(
        e =>
          e.pending &&
          (!e.isLinked ||
            (e.isLinked &&
              menuItemsHashTable &&
              menuItemsHashTable[e?.menuItemId]?.cardType === 1))
      )
      .reduce((a, v) => {
        // A pending item with no seatIds was ordered for the whole table,
        // so it applies to (and will later be split across) every seat.
        const isTableWideItem = getObjectValue(() => v.seatIds?.length === 0, true);
        const isSeatMatch =
          position.number !== -1 &&
          (
            isTableWideItem ||
            getObjectValue(
              () =>
                v.seatIds?.length > 0 &&
                v.seatIds.some(id => id === position.seatId),
              false
            )
          );

        if (isSeatMatch || position.number === -1) {
          a.push({ ...v, isCheck: false });
        }
        return a;
      }, []);
  return pendingItemsList.length > 0 ? reverse(pendingItemsList) : [];
};

export const styleGenerator = ({ sentItem, serverAppTheme, pendingList }) => {
  const itemsStyle = {
    border:
      sentItem?.length > 0 &&
        sentItem?.filter(e => e.isCheck)?.length === sentItem?.length
        ? 'none'
        : serverAppTheme?.checkbox_border,
    '--checkbox-checked-color': serverAppTheme?.checkbox_check_color,
    '--checkbox-checked-bg': serverAppTheme?.checkbox_checked,
  };
  const pendingItemStyle = {
    border:
      pendingList?.length > 0 &&
        pendingList.filter(e => e.isCheck).length === pendingList.length
        ? 'none'
        : serverAppTheme?.checkbox_border,
    '--checkbox-checked-color': serverAppTheme?.checkbox_check_color,
    '--checkbox-checked-bg': serverAppTheme?.checkbox_checked,
  };
  const pendingTabBg = {
    color: serverAppTheme?.primary_text,
    background: serverAppTheme?.pending_items,
    border: `2px solid ${serverAppTheme?.order_item_border}`,
  };
  const qtyStyle = { color: serverAppTheme?.secondary_text };
  const sentItemsStyle = {
    backgroundColor: serverAppTheme?.selectedCheck_bg,
    border: serverAppTheme?.select_border,
    color: serverAppTheme?.primary_text,
    height: '13.5%',
  };
  const pendingActiveTabStyle = {
    background: serverAppTheme?.selectedCheck_bg,
    border: serverAppTheme?.select_border,
    color: serverAppTheme?.primary_text,
    height: '13.5%',
  };
  const sentActiveTabStyle = {
    background: serverAppTheme?.selectedCheck_bg,
    border: serverAppTheme?.select_border,
    color: serverAppTheme?.primary_text,
  };
  const pendingTabStyle = {
    background: serverAppTheme?.selectedCheck_bg,
    border: serverAppTheme?.select_border,
    color: serverAppTheme?.primary_text,
  };

  const activeTab = {
    background: serverAppTheme?.order_item_Selected_bg,
    color: serverAppTheme?.primary_text,
    border: `2px solid ${serverAppTheme?.order_item_border}`,
  };
  const inActiveTab = {
    color: serverAppTheme?.primary_text,
    border: `2px solid ${serverAppTheme?.order_item_border}`,
  };
  const sendbtn = {
    backgroundColor: serverAppTheme?.primaryBtn,
  };
  return {
    itemsStyle,
    pendingItemStyle,
    qtyStyle,
    sentItemsStyle,
    pendingActiveTabStyle,
    sentActiveTabStyle,
    pendingTabStyle,
    activeTab,
    inActiveTab,
    sendbtn,
    pendingTabBg,
  };
};

const getOrderSendModeType = type => {
  switch (type) {
    case 'toGo':
      return 1;
    case 'doNotMake':
      return 2;
    case 'onTheFly':
    case 'runner':
      return 4;
    default:
      return 0;
  }
};

export const getLinkedMenuItemsId = ({
  data,
  type,
  orderId,
  allMenusHashTable,
  menuItemsHashTable,
  cart,
}) => {
  const menuList = [];
  data.forEach(item => {
    let printOrderTypeId = null;
    const groupItem = allMenusHashTable?.filter(
      Item => Item.id == item?.menuScreenId
    );
    if (
      groupItem[0]?.orderTypePrintRouting === true ||
      menuItemsHashTable[item?.menuItemId]?.orderTypePrintRouting === true
    ) {
      printOrderTypeId = orderId;
    }
    if (!item?.hasLinkedMenuItem) {
      menuList.push({
        checkOrderItemId: item?.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    } else {
      item?.modifiers?.forEach(e => {
        const linkedIndex = cart.findIndex(
          d =>
            d.menuItemId === e.modifierId &&
            d.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem
        );
        if (linkedIndex > -1) {
          menuList.push({
            checkOrderItemId: cart[linkedIndex].id,
            orderSendMode: getOrderSendModeType(type),
            printRoutingOrderTypeId: printOrderTypeId,
          });
        }
      });
      menuList.push({
        checkOrderItemId: item.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    }
  });
  return menuList;
};

export const sentCartButton = [
  {
    key: 'move',
    text: LABEL().MOVE,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'repeat',
    text: LABEL().REPEAT,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'void',
    text: LABEL().VOID,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'refill',
    text: LABEL().REFILL,
    backgroundColor: 'rgb(116, 164, 255)',
  },
];

export const pendingCartButton = [
  {
    key: 'move',
    text: LABEL().MOVE,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'repeat',
    text: LABEL().REPEAT,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'edit',
    text: LABEL().MODIFY,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'delete',
    text: LABEL().DELETE,
    backgroundColor: 'rgb(116, 164, 255)',
  },
  {
    key: 'send',
    text: LABEL().SEND,
    backgroundColor: 'rgb(37, 65, 164)',
  },
];
export const cartTypes = [
  {
    key: 'pending',
    label: LABEL().PENDING,
    refKey: 'pendingItems',
    show: true,
  },
  {
    key: 'sent',
    label: LABEL().SENT,
    refKey: 'items',
    show: true,
  },
];

export const activateGameCards = (data, menuItemsHashTable) => {
  let value = false;
  let items = data?.orders[0].items;
  items.forEach(i => {
    if (i.pending) {
      if (
        menuItemsHashTable[safeJsonParse(i.orderJson, {})?.menuItemId]
          ?.cardType == 1
      ) {
        value = true;
      }
    }
  });
  return value;
};

export const refillButtonVisibilityCheck = (data = {}) => {
  const { orders } = store.getState();
  const check = orders.seats;
  const menuItemsHashTable = orders.menuItemsHashTable;

  return (
    check.sourceType === 0 && menuItemsHashTable[data?.menuItemId]?.allowRefills
  );
};

export const itemVoidButtonVisibilityCheck = activeTab => {
  const { oauth, orders } = store.getState();
  const auth = oauth?.authInfo;
  const userInfo = oauth?.loggedInUserData;
  const check = orders?.seats;

  const job = (auth?.jobs ?? []).find(item => item?.id === userInfo?.jobId);
  const allowVoid = !!(auth?.nonIntegratedPos ? job?.allowVoid : false);

  return activeTab === 'sent' && allowVoid && check?.open !== false;
};

export const getButtonVisibility = () => {
  const {
    isDefaultMode,
    isWalkUp,
    isDriveThru,
    isCounter,
    isSpeedOrderMode,
    isTogo,
    isCallCenter,
    isServerApp,
  } = getDeviceType();

  const canMove =
    (isDefaultMode || isWalkUp || isServerApp) &&
    !isDriveThru &&
    !isCounter &&
    !isSpeedOrderMode &&
    !isTogo &&
    !isCallCenter;

  const canRepeat =
    (isDefaultMode || isWalkUp || isServerApp) &&
    !isDriveThru &&
    !isCounter &&
    !isSpeedOrderMode &&
    !isTogo &&
    !isCallCenter;

  const canDelete =
    isDefaultMode ||
    isWalkUp ||
    isDriveThru ||
    isCounter ||
    isCallCenter ||
    isSpeedOrderMode ||
    isTogo ||
    isServerApp;

  const canEdit =
    isDefaultMode ||
    isWalkUp ||
    isDriveThru ||
    isCounter ||
    isCallCenter ||
    isSpeedOrderMode ||
    isTogo ||
    isServerApp;

  const canSend = !isTogo;

  return { canMove, canRepeat, canDelete, canEdit, canSend };
};

export const repeatButtonVisibilityCheck = (data = []) => {
  const { orders } = store.getState();
  const items = orders?.seats?.orders[0]?.items || [];

  if (items.length === 0) return false;

  const itemIds = new Set(items.map(item => item?.checkItemId));
  return data.every(d => itemIds.has(d.id));
};

export const displayKdsStatus = status => {
  switch (status) {
    case 2:
      return panYellow;
    case 5:
      return panOrange;
    case 8:
      return panGreen;
    default:
      return null;
  }
};

export const getLocalTime = timeStamp => {
  const date = new Date(timeStamp);
  const newDate = new Date(
    date.getTime() + date.getTimezoneOffset() * 60 * 1000
  );

  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();

  newDate.setHours(hours - offset);
  let hour = newDate.getHours();
  let minute = newDate.getMinutes();

  let am_pm = 'a';
  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour = hour - 12;
    am_pm = 'p';
  } else if (hour === 12) {
    am_pm = 'p';
  }

  return `${hour.toString().padStart(2, '0')}:${minute
    .toString()
    .padStart(2, '0')}${am_pm}`;
};
